import { Stack, TextInput } from '@mantine/core'
import { useForm, zodResolver } from '@mantine/form'
import { ContextModalProps } from '@mantine/modals'
import Form from 'common/Form'
import { useAddManufacturer } from 'hooks/products'
import { NewManufacturer } from 'types/products'
import { manufacturerSchema } from 'types/schemas'
import { trimFormValues } from 'utils'

export default function AddManufacturerModal({ context, id }: ContextModalProps) {
  const addManufacturer = useAddManufacturer()

  const form = useForm<NewManufacturer>({
    validate: zodResolver(manufacturerSchema),
    transformValues: trimFormValues,
  })

  return (
    <Form
      onSubmit={async (values) => await addManufacturer.mutateAsync(values)}
      form={form}
      onCancel={() => context.closeModal(id)}
      submitText="Dodaj producenta"
    >
      <Stack gap="xs">
        <TextInput label="Nazwa producenta" placeholder="HAFT" withAsterisk {...form.getInputProps('name')} />
        <TextInput
          label="Email"
          description="Adres email na który wysyłane są zamówienia"
          placeholder="email@example.com"
          withAsterisk
          {...form.getInputProps('email')}
        />
      </Stack>
    </Form>
  )
}
